import { StyleGuide } from "../styleGuide/StyleGuide";
import { Demo } from "../styleGuide/Demo/Demo";
import { FAQ } from "../containers/LandingPageContainers/FAQ/FAQ";
import { ComingSoon } from "../containers/ComingSoon/ComingSoon";
import { Home } from "../containers/LandingPageContainers/Home/Home";
import { Pricing } from "../containers/LandingPageContainers/Pricing/Pricing";
import { SignUp } from "../containers/LandingPageContainers/SignUp/SignUp";
import { Contact } from "../containers/LandingPageContainers/Contact/Contact";
import { CalculatorROI } from "../containers/LandingPageContainers/CalculatorROI/CalculatorROI";
import { VerifyAccount } from "../containers/LandingPageContainers/SignUp/VerifyAccount/VerifyAccount";
import { SignUpVerifiedAccount } from "../containers/LandingPageContainers/SignUp/SignUpVerifiedAccount/SignUpVerifiedAccount";
import { Appointment } from "../containers/LandingPageContainers/Appointment/Appointment";
import { EmployerBlog } from "../containers/LandingPageContainers/Blogs/EmployerBlog/EmployerBlog";
import { TermsOfUse } from "../containers/LandingPageContainers/TermsOfUse/TermsOfUse";
import { AppointmentEnterDetails } from "../containers/LandingPageContainers/Appointment/AppointmentEnterDetails/AppointmentEnterDetails";
import { EmployerHelp } from "../containers/LandingPageContainers/EmployerHelp/EmployerHelp";
import { Account } from "../containers/LandingPageContainers/Account/Account";

export const routeList = [
    { id: 0, icon: "", path: "/style-guide", name: "Style Guide", element: <StyleGuide />, },
    { id: 1, icon: "", path: "/coming-soon", name: "Coming Soon", element: <ComingSoon />, },
    { id: 2, icon: "", path: "/", name: "Home", element: <Home />, },
    { id: 3, icon: "", path: "/signup", name: "SignUp", element: <SignUp />, },
    { id: 4, icon: "", path: "/verifyAccount", name: "Verify Account", element: <VerifyAccount />, },
    { id: 5, icon: "", path: "/signupVerified", name: "Sign Up Verified", element: < SignUpVerifiedAccount />, },
    { id: 6, icon: "", path: "/faq", name: "FAQ", element: <FAQ />, },
    { id: 7, icon: "", path: "/demo", name: "Demo", element: <Demo />, },
    { id: 8, icon: "", path: "/pricing", name: "Pricing", element: <Pricing />, },
    { id: 9, icon: "", path: "/calculatorROI", name: "CalculatorROI", element: <CalculatorROI />, },
    { id: 10, icon: "", path: "/contact", name: "Contact Us", element: <Contact />, },
    { id: 11, icon: "", path: "/appointment", name: "Appointment", element: <Appointment />, },
    { id: 12,icon: "",path: "/employerBlog",name: "Employers blog",element: <EmployerBlog/>,},
    { id: 13,icon: "",path: "/termsOfUse",name: "Terms Of Use",element: <TermsOfUse/>,},
    { id: 14, icon: "", path: "/appointmentEnterDetails", name: "Appointment EnterDetails", element: <AppointmentEnterDetails />, },
    { id: 15,icon: "",path: "/employerHelp",name: "EmployerHelp",element: <EmployerHelp/>,},
    { id: 16,icon: "",path: "/account",name: "Account",element: <Account/>,},

];